var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockThree = function SvgClockThree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#353333",
    d: "M13.602 8a5.6 5.6 0 1 1-11.2 0 5.6 5.6 0 0 1 11.2 0m-12 0a6.4 6.4 0 1 0 12.8 0 6.4 6.4 0 0 0-12.8 0m6-3.6v4h3.6v-.8h-2.8V4h-.8z"
  })));
};
export default SvgClockThree;